import { CatalogAttributeFields, formatAttributeValue } from '../../catalog/CatalogAttributeFields';

export { formatAttributeValue };
export const ProductAttributeFields = CatalogAttributeFields;
